<template>
  <div class="edition-select">
    <van-overlay :show="loading">
      <div class="load-wp">
        <van-loading
          size="38px"
          color="#69E09F"
        >加载中...</van-loading>
      </div>
    </van-overlay>
    <banner-cp :banner='cp_banner' v-if='cp_banner'></banner-cp>
    <div class="mainer">
      <div class="sTitle" v-if="list.length">请选择教材版本</div>
      <div class="sTitle" v-else>暂无可选版本</div>
      <div
        class="blcok"
        v-for="(itm, idx) in list"
        :key="idx"
      >
        <div class="bTitle">
          请先选择
          <span class="color-orange">{{itm.subjectName}}课本</span>出版社
        </div>
        <ul class="sItem">
          <li
            v-for="(item,index) in itm.editions"
            :key="index"
            @click="setEdition(item,itm)"
            :class="{hover: item.active}"
          >{{item.editionName}}</li>
        </ul>
        <ul>
          <div v-for="(item,index) in itm.editions"  :key="index" v-show="item.active">
            <span class="color-orange">{{item.editionName}}</span><span>册别：</span>
            <div @click="setTerm(term, item)" :class="{'btn-term-div-active': item.termActive === term}"  class="btn-term-div" v-for="(term,index2) in item.termIds"  :key="index2" v-text="term===1 ? '上册' : '下册'"></div>
          </div>
        </ul>
      </div>
      <div class="sButton" v-if="list.length">
        <button
          class="btn"
          @click="goHome"
        >确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
import { cd_baseUrl } from '@/assets/js/api'
import bannerCp from '@/components/common/Banner'

export default {
    name: 'EditionSelect',
    components:{
        bannerCp
    },
    data () {
        return {
            loading: false,
            list: [],
            params: {
                gradeSelectResult: {
                    gradeId: 6,
                    gradeName: "六年级"
                },
                eduSystemId: 1,
                periodId: 1,
                lessonId: 1,
            }  //年级组件选择结果
        }
    },
    created () {
      if(!sessionStorage.getItem('notLoadFirst')) {
        sessionStorage.setItem('notLoadFirst',true);
        window.location.reload();

      }
    },
    mounted () {
        this.params = paramsHelper.decode(this.$route.query.params);
        let { gradeSelectResult, eduSystemId, periodId, lessonId } = this.params
        this.getSubjectAndEditionList(lessonId, gradeSelectResult.gradeId, eduSystemId, periodId)
    },
    computed: {
        cp_banner () {
            return sessionStorage.getItem('banner')
        }
    },
    methods: {
        getSubjectAndEditionList (lessonId, gradeId, eduSystemId, periodId) {
            var that = this;
            that.loading = true
            this.$axios.get(cd_baseUrl + '/microClassCustom/link/subjectAndEditionList', {
                params: {
                    lessonId,
                    gradeId,
                    eduSystemId,
                    periodId,
                }
            }).then(function (res) {
                var sevenMonth = new Date(new Date().toLocaleDateString());
                sevenMonth.setMonth(6);
                sevenMonth.setDate(1);

                var twoMonth = new Date(new Date().toLocaleDateString());
                twoMonth.setMonth(1);
                twoMonth.setDate(1);

                var nowTime = Date.now();

                if (res && res.data.errcode === 0) {
                    let list = res.data.data.list.filter(v => v.editions.length !== 0 );
                    that.list = list.map(value => {
                        return Object.assign(value, {
                            editions: value.editions.map(({ editionId, editionName, active = false, termActive = 1, termIds}, idx) => {
                                return {
                                    editionId,
                                    editionName,
                                    termIds,
                                    termActive: termIds.length>1 ? (nowTime>=twoMonth.getTime() && nowTime<sevenMonth.getTime() ? termIds[1] : termIds[0]) : termIds[0],
                                    active: idx === 0
                                }
                            })
                        })
                    })
                    
                } else {
                    that.$toast(res.data.errmsg)
                }
                that.loading = false
            }).catch(function (err) {
                that.loading = false;
                that.$toast(err.errmsg || err.data.errmsg);
            });
        },
        setEdition (item, itm) {
            this.list = this.list.map(value => {
                return Object.assign(value, {
                    editions: value.editions.map(({ editionId, editionName, active, termActive, termIds}) => {
                        return {
                            editionId,
                            editionName,
                            termIds,
                            termActive,
                            active: (value.subjectId === itm.subjectId && editionId === item.editionId) || (value.subjectId !== itm.subjectId && active)
                        }
                    })
                })
            })
        },
        setTerm (term, item) {
            item.termActive = term;
        },
        goHome () {
            if (!this.list.length) {
                return
            }
            let editionSelectResult = this.list.map(({ subjectId, subjectName, editionName, termActive, editions }) => {
                return {
                    subjectId,
                    subjectName,
                    editionName,
                    termActive,
                    editions: editions.filter(itm => itm.active)
                }
            })

            this.$router.push({
                name: 'Home',
                query: { params: paramsHelper.encode({ editionSelectResult,
                    gradeSelectResult: this.params.gradeSelectResult,
                    eduSystemId: this.params.eduSystemId,
                    periodId: this.params.periodId,
                    lessonId: this.params.lessonId, }),lessonId: this.params.lessonId, }
            })
        },
    }
}
</script>

<style scope>
  .btn-term-div{
    display: inline-block;
    border-radius: 0.5rem;
    border: 1px solid #c2c2c2;
    padding: 0.15rem 0;
    margin: 0 0.3rem 0.3rem 0;
    width: 20%;
    text-align: center;
    color: #666;
    cursor: pointer;
  }
  .btn-term-div-active, .btn-term-div:hover{
    border: 1px solid #0be197;
    background-color: #0fe59b;
  }
.edition-select {
}
</style>
